import { QueryClient } from '@tanstack/react-query';
import { oneHour } from './constants';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      staleTime: oneHour,
    },
  },
});
